import { root } from './plans';

export const plans = {
  ...root,
};
